import { React, useState, useEffect } from 'react';
import { Stack, Divider, Typography, Tooltip } from '@mui/material';
import ActionButton from '../lib/ActionButton';

export default function OAuthLoginButtons() {
    const [providers, setProviders] = useState([]);

    useEffect(() => {
        fetch('/api/v1/auth/providers')
            .then(res => res.ok ? res.json() : [])
            .then(setProviders)
            .catch(() => setProviders([]));
    }, []);

    if (providers.length === 0) return null;

    return (
        <>
            <Divider sx={{ my: 2 }}>
                <Typography variant="body2" color="text.secondary">or</Typography>
            </Divider>
            <Stack spacing={1}>
                {providers.map(p => {
                    const buttonText = p.ui?.buttonText || `Login with ${p.name}`;
                    const tooltip = p.ui?.tooltip || `Sign in using ${p.name}`;
                    const color = p.ui?.color;
                    const icon = p.ui?.icon;

                    return (
                        <Tooltip key={p.id} title={tooltip} arrow>
                            <ActionButton
                                variant="outlined"
                                fullWidth
                                onClick={() => { window.location.href = `/api${p.loginUrl}`; }}
                                sx={color ? { borderColor: color, color, '&:hover': { borderColor: color, backgroundColor: `${color}10` } } : {}}
                                startIcon={icon ? <img src={icon} alt="" style={{ width: 20, height: 20 }} /> : null}
                            >
                                {buttonText}
                            </ActionButton>
                        </Tooltip>
                    );
                })}
            </Stack>
        </>
    );
}
